import React from "react";
import { Card, Statistic, Badge } from "antd";
import { motion } from "framer-motion";

interface ImpactMetricCardProps {
  title: string;
  value: number | string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  valueColor?: string;
  delay?: number;
  flag?: "red" | "orange" | "green";
  threshold?: string;
  precision?: number;
}

export const ImpactMetricCard: React.FC<ImpactMetricCardProps> = ({
  title,
  value,
  prefix,
  suffix,
  valueColor = "#1890ff",
  delay = 0,
  flag,
  threshold,
  precision,
}) => {
  const getFlagBadge = () => {
    if (!flag) return null;
    const statusMap = {
      red: "error",
      orange: "warning",
      green: "success",
    };
    return <Badge status={statusMap[flag] as any} />;
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, delay }}
      whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
    >
      <Card
        style={{
          height: "100%",
          background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          border: "1px solid #e8e8e8",
          borderTop: flag
            ? `3px solid ${flag === "red" ? "#ff4d4f" : flag === "orange" ? "#faad14" : "#52c41a"}`
            : "1px solid #e8e8e8",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: delay + 0.2 }}
            style={{ flex: 1 }}
          >
            <Statistic
              title={title}
              value={value}
              prefix={prefix}
              suffix={suffix}
              valueStyle={{ color: valueColor, fontWeight: 600 }}
              precision={precision}
            />
          </motion.div>
          {getFlagBadge()}
        </div>
        {threshold && (
          <motion.div
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: delay + 0.3 }}
            style={{ marginTop: 8, fontSize: 11, color: "#8c8c8c" }}
          >
            Threshold: {threshold}
          </motion.div>
        )}
      </Card>
    </motion.div>
  );
};
